import { motion } from "framer-motion";
import { Lightbulb } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Reveal } from "./Reveal";
import { goToContact } from "@/lib/scroll";

export const IdeaCallout = () => (
  <section data-testid="idea-section" className="px-3 py-10 sm:px-6">
    <Reveal className="relative mx-auto max-w-7xl overflow-hidden rounded-[2rem] bg-ws-lime px-6 py-16 text-ws-bg sm:rounded-[2.5rem] sm:px-12 sm:py-24">
      <div className="pointer-events-none absolute inset-0 opacity-[0.18]" style={{ backgroundImage: "radial-gradient(#050706 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <motion.div
        aria-hidden="true"
        animate={{ rotate: 360 }}
        transition={{ duration: 50, repeat: Infinity, ease: "linear" }}
        className="pointer-events-none absolute -right-32 -top-32 h-[420px] w-[420px] rounded-full border-[1.5px] border-dashed border-ws-bg/25 sm:-right-20"
      />
      <img src="/img/emblem.webp" alt="" aria-hidden="true" className="pointer-events-none absolute -bottom-10 -right-10 w-[340px] opacity-[0.16] mix-blend-multiply grayscale sm:w-[520px]" />
      <div className="relative max-w-3xl">
        <span className="inline-grid h-14 w-14 place-items-center rounded-2xl bg-ws-bg text-ws-lime">
          <Lightbulb size={26} className="icon-bob" />
        </span>
        <h2 className="mt-8 font-display text-3xl font-semibold leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl">
          Você tem uma ideia? A WebStation transforma em realidade.
        </h2>
        <p className="mt-6 max-w-2xl text-base font-medium leading-relaxed text-ws-bg/80 md:text-lg">
          Conte o que você precisa. Nós pensamos na estrutura, experiência, tecnologia e desenvolvimento para transformar sua ideia em uma solução digital profissional.
        </p>
        <CTAButton testid="idea-cta" variant="dark" className="mt-10" onClick={() => goToContact("Solução personalizada")}>
          Quero tirar minha ideia do papel
        </CTAButton>
      </div>
    </Reveal>
  </section>
);
